<template>
  <div class="container_wrapper">
    <left-menu
      title="测风塔列表"
      :showChildren="false"
      module-type="towerList"
    ></left-menu>
    <main-content></main-content>
  </div>
</template>

<script>
import leftMenu from '../components/left-menu';
import mainContent from './content';
export default {
  mounted() {
    this.$store.commit('WindData/SHOW_DOWNLOAD_TABLE', true);
  },
  components: {
    leftMenu,
    mainContent
  }
};
</script>

<style></style>
